import React, {Component, Fragment} from 'react'

class ExamConfigBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null
        }
    }

    handleOptionChange(e) {
        // console.log(e.target.value);

        this.setState({
            selectedOption: e.target.value
        })
    }

    onStart() {
        const { id, options, onStart } = this.props;
        const { selectedOption } = this.state;

        if(options && !selectedOption) {
            return
        }

        onStart(id, selectedOption)
    }

    render() {
        const { title, description, options, icon } = this.props;
        const { selectedOption } = this.state;

        return (
            <div className="exam-config-box">
                <div className="exam-config-box__icon-area">
                    <i className={`icon-${ icon }`} />
                </div>
                <div className="exam-config-box__content">
                    <h6>{ title }</h6>
                    <p>{ description }</p>
                    <div className="exam-config-box__options">
                    {
                        options && options.map(option => {
                            return (
                                <Fragment key={option.value}>
                                    <input
                                        id={title.replace(' ', '-') + '-' + option.value}
                                        checked={selectedOption === option.value}
                                        value={option.value}
                                        type="radio"
                                        onChange={e => this.handleOptionChange(e)}
                                    />
                                    <label htmlFor={title.replace(' ', '-') + '-' + option.value}>{ option.text }</label>
                                </Fragment>
                            )
                        })
                    }
                    </div>
                    <button
                        type="button"
                        className="small success button"
                        onClick={() => this.onStart()}
                        disabled={options && !selectedOption}
                    >
                        Iniciar
                    </button>
                </div>
            </div>
        )
    }
}

export { ExamConfigBox }
